type FormatPriceOptions = {
  amount: number;
  currency: string;
  locale: string;
};

export default function formatPrice({
  amount,
  currency,
  locale,
}: FormatPriceOptions) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
}
